import React from 'react';

import { Box, Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import action_library_messages from 'messages/action_library_messages';

import { ActionLibraryInstanceFormValues } from '../../ActionLibraryInstanceForm.types';

import AssetSelectionList from './AssetSelectionList/AssetSelectionList';

const StepAssetSelection: React.FC = () => {
  const { t } = useTranslation();
  const { values } = useFormikContext<ActionLibraryInstanceFormValues>();

  const selectedCount = Array.isArray(values.selectedAssets) ? values.selectedAssets.length : 0;

  return (
    <Box>
      <Box mb={4}>
        <Typography gutterBottom variant='h6'>
          {t(action_library_messages.instance.asset_selection.title)}
        </Typography>
        <Typography color='textSecondary' paragraph variant='body2'>
          {t(action_library_messages.instance.asset_selection.description)}
        </Typography>

        <AssetSelectionList />
      </Box>

      {selectedCount > 0 && (
        <Typography color='primary' variant='subtitle2'>
          {t(
            selectedCount === 1
              ? action_library_messages.instance.asset_selection.selected_count
              : action_library_messages.instance.asset_selection.selected_count_plural,
            { count: selectedCount },
          )}
        </Typography>
      )}
    </Box>
  );
};

export default StepAssetSelection;
